'use client';

import { cn } from '@ifixit/ui/lib/utils';
import type { InputHTMLAttributes } from 'react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
   onCheckedChange?: (checked: boolean) => void;
}

export function Checkbox({ className, onCheckedChange, onChange, ...props }: CheckboxProps) {
   return (
      <input
         type="checkbox"
         data-slot="checkbox"
         className={cn(className)}
         onChange={e => {
            onChange?.(e);
            onCheckedChange?.(e.target.checked);
         }}
         {...props}
      />
   );
}
